module.exports = __webpack_public_path__ + "static/media/1.e9f68bd6.jpg";